import { render, staticRenderFns } from "./dts.vue?vue&type=template&id=459a53ef&scoped=true"
import script from "./dts.vue?vue&type=script&lang=js"
export * from "./dts.vue?vue&type=script&lang=js"
import style0 from "./dts.vue?vue&type=style&index=0&id=459a53ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a53ef",
  null
  
)

export default component.exports